export default function initAjaxFilter(): void {
    const categoryLinks = document.querySelectorAll('.categories-nav a');
    categoryLinks.forEach(link => {
        link.addEventListener('click', (event) => {
            event.preventDefault();
            const target = event.currentTarget as HTMLAnchorElement;
            const categorySlug = target.getAttribute('href');
            updateFilterActive(categorySlug);

            if (categorySlug !== null) {
                showLoadingState(); // Montre l'état de chargement
                loadFilteredPosts(categorySlug);
            }
        });
    });

    initPagination();
}

function initPagination() : void {
    const paginateLinks = document.querySelectorAll('.pagination a');
    paginateLinks.forEach(link => {
        link.addEventListener('click', (event) => {
            event.preventDefault();
            const target = event.currentTarget as HTMLAnchorElement;
            const categorySlug = target.getAttribute('href');
            if (categorySlug !== null) {
                showLoadingState(); // Montre l'état de chargement
                loadFilteredPosts(categorySlug);
            }
        });
    });
}

function updateFilterActive(categorySlugActive: string | null): void {
    const categoryLinks = document.querySelectorAll('.categories-nav a');
    
    categoryLinks.forEach(link => {
        const categorySlug = link.getAttribute('href');
        link.classList.remove('active');
        if (categorySlug === categorySlugActive) {
            link.classList.add('active');
        }
    });
}


function loadFilteredPosts(categorySlug: string): void {
    fetch(categorySlug)
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.text();
        })
        .then(html => {
            updatePostsContainer(html);
            updateUrl(categorySlug);
            hideLoadingState(); // Cache l'état de chargement après la réussite
            initPagination();
        })
        .catch(error => {
            console.error('Fetch operation error:', error);
            hideLoadingState(); // Cache l'état de chargement après une erreur
        });
}


function updatePostsContainer(html: string): void {
    const container = document.createElement('div');
    container.innerHTML = html;
    const content = container.querySelector('.article-ajax-container');
    const postsContainer = document.querySelector('.article-ajax-container');
    
    if (postsContainer && content) {
        const animatedElements = content.querySelectorAll('.anim-element');
        animatedElements.forEach(element => {
            element.classList.add('appear');
        });
        
        postsContainer.innerHTML = content.innerHTML;
    }
}

function updateUrl(categorySlug: string): void {
    const newUrl = categorySlug;
    window.history.pushState({ path: newUrl }, '', newUrl);
}

function showLoadingState(): void {
    const postsContainer = document.querySelector('.block-posts-list') as HTMLElement;
    const categoriesNav = document.querySelector('.categories-nav') as HTMLElement;
    if (postsContainer) {
        postsContainer.classList.add('loading');
    }
    if (categoriesNav) {
        categoriesNav.classList.add('loading');
    }
}

function hideLoadingState(): void {
    const postsContainer = document.querySelector('.block-posts-list') as HTMLElement;
    const categoriesNav = document.querySelector('.categories-nav') as HTMLElement;
    if (postsContainer) {
        postsContainer.classList.remove('loading');
    }
    if (categoriesNav) {
        categoriesNav.classList.remove('loading');
    }
}
